import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEO from '../../components/feature/SEO';
import DonateHeroSection from './components/DonateHeroSection';
import IndividualGivingSection from './components/IndividualGivingSection';
import CSRPartnershipsSection from './components/CSRPartnershipsSection';
import TransparencySection from './components/TransparencySection';
import FinalCTASection from './components/FinalCTASection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const schema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/donate#webpage`,
      url: `${siteUrl}/donate`,
      name: 'Donate | Fund Oxygen Supplementation for Families – Diatomic Life Foundation',
      description:
        'Your donation funds oxygen supplementation, AI health screening, and education for underserved families. 92% of every rupee goes directly to impact. Donate now.',
      isPartOf: { '@id': `${siteUrl}/#website` },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
          { '@type': 'ListItem', position: 2, name: 'Donate', item: `${siteUrl}/donate` },
        ],
      },
    },
    {
      '@type': 'DonateAction',
      '@id': `${siteUrl}/donate#action`,
      name: 'Donate to Diatomic Life Foundation',
      description:
        'Support Diatomic Life Foundation by donating to fund oxygen supplementation, education, and AI screening for families in need across India.',
      url: `${siteUrl}/donate`,
      recipient: {
        '@type': 'NGO',
        '@id': `${siteUrl}/#organization`,
        name: 'Diatomic Life Foundation',
        url: siteUrl,
      },
      object: {
        '@type': 'MonetaryAmount',
        currency: 'INR',
        description: '92% of every donation goes directly to oxygen supplementation products and programs.',
      },
    },
  ],
};

export default function Donate() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Donate | Fund Oxygen Supplementation for Families – Diatomic Life Foundation"
        description="Your donation funds oxygen supplementation, AI health screening, and education for underserved families. 92% of every rupee goes directly to impact. Donate now."
        keywords="donate oxygen, fund oxygen supplementation, NGO donation India, Diatomic Life Foundation donate"
        canonical={`${siteUrl}/donate`}
        schemaJson={schema}
      />
      <Header />
      <main>
        <DonateHeroSection />
        <IndividualGivingSection />
        <CSRPartnershipsSection />
        <TransparencySection />
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
}
